"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classNames_1 = __importDefault(require("../../../lib/classNames"));
var getEffectiveImageSize_1 = __importDefault(require("../lib/getEffectiveImageSize"));
var getGifSources_1 = __importDefault(require("./lib/getGifSources"));
var getGifPoster_1 = __importDefault(require("./lib/getGifPoster"));
var UploadcareGif = function (props) {
    var className = props.className, containerClassName = props.containerClassName, layout = props.layout, objectFit = props.objectFit, imageDetails = props.imageDetails, width = props.width, height = props.height, src = props.src, objectPosition = props.objectPosition;
    var sources = getGifSources_1.default(props);
    var poster = getGifPoster_1.default(props);
    var imageStyle = layout === 'fixed'
        ? undefined
        : {
            objectFit: objectFit,
            objectPosition: objectPosition,
            maxHeight: height,
            maxWidth: width,
            minHeight: height,
            minWidth: width,
        };
    var videoSize = getEffectiveImageSize_1.default(width, height, imageDetails);
    return (react_1.default.createElement("video", __assign({}, videoSize, { className: classNames_1.default('uploadcare-image__gif', layout === 'fill' && 'uploadcare-image__layout-fill', containerClassName || className), poster: poster, style: imageStyle, autoPlay: true, loop: true, muted: true, playsInline: true }), sources.map(function (source) { return (react_1.default.createElement("source", { key: "" + (src || (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.uuid)) + source.format, src: source.src, type: source.type })); })));
};
exports.default = UploadcareGif;
//# sourceMappingURL=Gif.js.map